import axios from 'axios';

let debugInitialized = false;

export function setupAxiosDebug() {
  if (debugInitialized) {
    return;
  }

  axios.interceptors.request.use(
    (request) => {
      console.group('[API Request]');
      console.log('Method:', request.method?.toUpperCase() || 'GET');
      console.log('URL:', request.url || '');
      console.log('Payload:', request.data ?? null);
      console.log('Headers:', request.headers ?? null);
      console.groupEnd();
      return request;
    },
    (error) => {
      console.group('[API Request Error]');
      console.error(error);
      console.groupEnd();
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      console.group('[API Response]');
      console.log('Status:', response.status);
      console.log('URL:', response.config?.url || '');
      console.log('Response:', response.data ?? null);
      console.groupEnd();
      return response;
    },
    (error) => {
      console.group('[API Response Error]');
      console.log('Status:', error?.response?.status ?? null);
      console.log('URL:', error?.config?.url || '');
      console.log('Response:', error?.response?.data ?? null);
      console.error(error);
      console.groupEnd();
      return Promise.reject(error);
    }
  );

  debugInitialized = true;
}
